module.exports = __webpack_public_path__ + "0996256f909651b07f45e53b5c3dedb7.jpeg";